import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastProvider } from './components/ui/toast';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import RegistrationPage from './pages/RegistrationPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import RegistrationList from './pages/RegistrationList';
import RegistrationCompletePage from './pages/RegistrationCompletePage';

/**
 * 전시회 등록시스템 메인 앱 컴포넌트
 * 라우팅과 전체 애플리케이션의 진입점 역할을 합니다.
 */
function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <Router>
          <div className="App">
            <Routes>
              {/* 전시회별 사전등록 페이지 */}
              <Route path="/pre-register/urbanbreak" element={<RegistrationPage exhibitionType="urbanbreak" />} />
              <Route path="/pre-register/toycon" element={<RegistrationPage exhibitionType="toycon" />} />
              
              {/* 기존 사전등록 페이지 - 기본적으로 urbanbreak로 리디렉션 */}
              <Route path="/pre-register" element={<Navigate to="/pre-register/urbanbreak" replace />} />
              
              {/* 등록 완료 페이지 */}
              <Route path="/complete/:id" element={<RegistrationCompletePage />} />
              
              {/* 관리자 로그인 - Electron 앱 시작 페이지 */}
              <Route path="/admin/login" element={<AdminLogin />} />
              
              {/* 관리자 대시보드 - 인증 필요 */}
              <Route path="/admin" element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } />
              
              {/* 등록자 목록 관리 - 인증 필요 */}
              <Route path="/admin/registrations" element={
                <ProtectedRoute>
                  <RegistrationList />
                </ProtectedRoute>
              } />
              
              {/* 기본 라우트 - 브라우저는 사전등록 페이지로, Electron은 관리자 로그인으로 */}
              <Route path="/" element={
                <Navigate to={
                  // Electron 환경인지 확인
                  typeof window !== 'undefined' && (window as any).electronAPI
                    ? "/admin/login"
                    : "/pre-register/urbanbreak"
                } replace />
              } />
              
              {/* 기타 모든 경로 */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </ToastProvider>
  );
}

export default App;
